<template>
    <div class="action-table">
        <v-client-table
            :data="tableData"
            :columns="columns"
            :options="options"
            ref="table"
        >
            <colored-letter-square
                slot="cls_column"
                slot-scope="props"
                :name="props.row.role_trans"
                :length="1"
                :color="setColorOfColoredLetterSquare(props.row.role_trans)"
            >
            </colored-letter-square>

            <div slot="name" slot-scope="props">
                <div class="VueTables__primary-content-bold">
                    {{ props.row.name }}
                </div>
                <div class="VueTables__secondary-content">
                    {{ props.row.username }}<br />{{ props.row.email }}
                </div>
            </div>
            <div slot="clientname" slot-scope="props">
                {{ props.row.clientname }}
            </div>
            <div slot="tenant" slot-scope="props">
                {{ props.row.tenant_name }}
            </div>

            <div slot="actions" slot-scope="props">
                <GlobalSearchActions
                    :data="props.row"
                    :index="props.index"
                    :url="route('tenant.users.index')"
                ></GlobalSearchActions>
            </div>
        </v-client-table>
    </div>
</template>

<script>
import { Event } from 'vue-tables-2';
import { EventBus } from '../eventbus';

export default {
    data() {
        return {
            tableData: [],
            columns: ['cls_column', 'name', 'clientname', 'tenant', 'actions'],
            options: {
                headings: {
                    cls_column: '',
                    name: this.trans('global_search.usertable.label.name'),
                    clientname: this.trans(
                        'global_search.usertable.label.clientname'
                    ),
                    tenant: this.trans('global_search.usertable.label.tenant'),
                    actions: this.trans('vuetables.label.actions'),
                },

                texts: {
                    count: this.trans('vuetables.label.countText'),
                    noResults: this.trans('vuetables.label.noResults'),
                },

                sortable: ['tenant'],
            },
        };
    },

    methods: {
        setColorOfColoredLetterSquare(role) {
            // spilt for multiple roles, select the first role as main color.
            switch (role.split(',')[0]) {
                case this.trans('users.role.admin'):
                    return '#9acd7d';
                case this.trans('users.role.editor'):
                    return '#9ddbd7';
                case this.trans('users.role.accounting'):
                    return '#f48fb1';
                case this.trans('users.role.client_admin'):
                    return '#b39ddb';
                case this.trans('users.role.controller'):
                    return '#f5b266';
                case this.trans('users.role.end_user'):
                    return '#64b5f6';
                case this.trans('users.role.support'):
                    return '#db9dd9';
                default:
                    return '#007d40';
            }
        },
    },

    mounted() {
        EventBus.$on('globalSearchUser', inputUser => {
            axios
                .post('/api/main/global-search/user', { input_user: inputUser })
                .then(data => {
                    this.tableData = data.data.data;
                });
        });
    },
};
</script>
